import { useEffect } from 'react';
import { TextField } from '@material-ui/core';
import { createFormField } from '@backstage/plugin-scaffolder-react/alpha';
import { useTemplateDefaults } from './useTemplateDefaults';

export function ConfiguredGithubOwnerComponent(props: {
  formData?: string;
  onChange: (value: string) => void;
  schema?: { title?: string };
  idSchema?: { $id: string };
}) {
  const { defaults, error } = useTemplateDefaults();
  const owner = defaults?.githubOwner;
  useEffect(() => {
    if (owner && props.formData !== owner) props.onChange(owner);
  }, [owner, props.formData, props.onChange]);
  return (
    <TextField
      id={props.idSchema?.$id}
      label={props.schema?.title || 'GitHub Owner / Organization'}
      value={owner || ''}
      InputProps={{ readOnly: true }}
      error={Boolean(error)}
      helperText={error || (owner ? 'Configured by the platform' : 'Loading…')}
      fullWidth
      variant="outlined"
      margin="normal"
    />
  );
}

export const ConfiguredGithubOwner = createFormField({
  name: 'ConfiguredGithubOwner',
  component: ConfiguredGithubOwnerComponent as any,
});
